/**
 * @config cdnUrl OSS服务地址
 * @config appUrl API服务器地址 测试版https://xz.yixiaozhi.com  正式版https://www.yixiaozhi.com
 * @config imgUrl 本地服务上传图片前缀域名  测试版https://admin.yixiaozhi.com 正式版https://bigboss.yixiaozhi.com
 * @config debug 全局调试
 *
 */
export default {
  cdnurl: 'https://yxzshop.oss-cn-beijing.aliyuncs.com',
  appurl: 'https://www.yixiaozhi.com',
  imgUrl: 'https://bigboss.yixiaozhi.com',
  versionName: '2.0',
  versionCode: '20',
  debug: false

}



//////////////////
// WEBPACK FOOTER
// ./common/config/config.js
// module id = 81
// module chunks = 0